import { render, staticRenderFns } from "./side-container-style2.vue?vue&type=template&id=aecb7a5e&scoped=true&"
import script from "./side-container-style2.vue?vue&type=script&lang=js&"
export * from "./side-container-style2.vue?vue&type=script&lang=js&"
import style0 from "./side-container-style2.vue?vue&type=style&index=0&id=aecb7a5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aecb7a5e",
  null
  
)

export default component.exports